<div class="wk-file-upload">
  <header mat-dialog-header>
    <h3 class="upload-title">{{ 'APP.ACTIONS.UPLOAD_FILES' | translate }}</h3>
    <span
      class="wk-icon-close"
      (click)="closeDialog()"
      (keyup)="closeDialog()"
    ></span>
  </header>
  <p class="upload-desc">
    {{ 'APP.ACTIONS.SELECT_DOCUMENT_TYPE_ENTRY' | translate }}
  </p>
  <wk-upload-files-list
    [fileNamesToUpload]="fileNames"
    [directoryName]="directory"
    [files]="files"
    [documentType]="documentType"
  ></wk-upload-files-list>
</div>
<div mat-dialog-actions class="upload-dialog-actions">
  <button
    type="button"
    (click)="closeDialog()"
    class="wk-button wk-button-text cancel"
  >
    {{ 'APP.ACTIONS.CANCEL' | translate }}
  </button>
  <button
    type="button"
    [disabled]="canUploadFiles()"
    class="wk-button upload-btn"
    #uploadButton
  >
    {{ 'APP.ACTIONS.UPLOAD_BUTTON_TEXT' | translate }}
  </button>
</div>
